import { FC } from "react";

import { FootnoteAnchor, PricingFootnotes } from "../../components/Anchor";
import { Button } from "../../components/Button";
import { Footnote } from "../../components/Link";
import HandCoins from "../../public/webstatic/svg/hand-coins.svg";
import { BrokerageWebPath } from "../../utils/paths";

export const PricingHero: FC = () => {
  return (
    <section className="bg-frecDarkBeige grid grid-cols-[auto_minmax(0,86rem)_auto] overflow-x-hidden lg:grid-rows-[76px_1fr_1px]">
      <div className="">{/* empty */}</div>
      <div className="dotted-v lg:mx-12 lg:border-x">{/* empty */}</div>
      <div className="">{/* empty */}</div>
      {/* row */}
      <div className="">{/* empty */}</div>
      <div className="dotted-v lg:mx-12 lg:border-x">
        <div className="my-32 flex flex-col items-center justify-center gap-4 text-center lg:my-24">
          <h1 className="text-[30px] leading-tight text-balance lg:text-[48px]">
            Tax loss harvest your fees away
          </h1>
          <p className="lg:text-20">
            Direct index for as little as 0.10% annually,
            <br />
            or just <span className="whitespace-nowrap">$20/year</span> for a
            $20,000 portfolio.
            <br />
            <br />
          </p>
          <div className="mx-4 max-w-96 rounded-full bg-[#FDFCF780] px-5 py-2 md:max-w-full">
            <HandCoins
              className="mr-2 inline"
              width={32}
              height={32}
              alt="Hand holding coins"
            />
            <span className="align-middle">With your tax savings, </span>
            <span className="text-frecBlue align-middle">
              it could pay for itself up to 21 times over.
              <Footnote anchor={FootnoteAnchor.DITaxAlphaDisclaimer}>
                <sup>{PricingFootnotes.withDITaxAlphaDisclaimer}</sup>
              </Footnote>
            </span>
          </div>
          <Button
            variant="blue"
            className="mt-8"
            onClick={() => (location.href = BrokerageWebPath.signup)}
          >
            Start investing
          </Button>
        </div>
      </div>
      <div className="dotted-h col-span-3 border-b">{/* empty */}</div>
    </section>
  );
};
